import { ajax } from '../../../services/helper'
class ApiService {

    getAssetLocationsData = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/assetLocations/list"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

   
    getAssetLocationById = (id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/assetLocations/"+id+"/editInfo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getAssetLocationGroupsDetailList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/brandGroups/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

     getPlatformsComboList = () => {
        return new Promise((resolve, reject) => {
            const url = "/v1/platforms/getCombo"
            ajax(url, 'GET')
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }

    
    


    addAssetLocation = (data) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/assetLocations/add"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }


    editAssetLocation = (data,id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/assetLocations/"+id+"/update"
            ajax(url,'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }



    
}
export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/Asset Locations/services/apiservices.js